import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

interface Params {
    shopId: string;
}

const ShopPrepareModal: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { shopId } = params;
  const { pop, push } = useFlow();
  const handleMove = () => {
    pop({ animate: false });
    push('ItemsActivity', { shopId, type: 'ALL' });
  };
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={36}>
                    <Text size='xl' align='center'>
                        매장 준비중입니다.<br/>
                        메뉴를 보러 가실래요?
                    </Text>
                    <Column fullWidth spacing={8}>
                        <Button fullWidth variant='secondary' onClick={pop}>취소</Button>
                        <Button fullWidth
                                onClick={handleMove} >
                            메뉴 보러 가기
                        </Button>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default ShopPrepareModal;
